<template>
  <div id="sidebar" class="sidebar">
    <div class="d-flex flex-row h-100">
      <!-- <div
        class="p-2 bd-highlight workspace-sideba"
        style="top: 0px;left: 0px;
        min-width: 60px;
        max-width: 60px;
        min-height: 768px;
        max-height: 100%;
        background: #5445F3 0% 0% no-repeat padding-box;
        box-shadow: 0px 1px 6px #00000029;
        opacity: 1;"
      >Flex item 1</div>-->
      <div
        class="d-flex flex-column workspace-sidebar"
        style="display: none !important"
      >
        <!-- <div
          class="flex-grow-1 pt-2"
          style="opacity: 1;
                 font-family: Comfortaa, cursive;
                 font-size: 2em;
                 text-transform: none;
                 padding-left: 1.25rem !important;"
        >fi</div>-->
        <div class="flex-grow-1 pt-2">
          <div class="d-flex flex-column">
            <div class="workspace-logo">fi</div>
            <div style="padding-top: 5px; padding-left: 10px">
              <a
                :href="`#/${$route.params.account_id}/${$route.params.workspace_id}/workspace`"
              >
                <div
                  class="nineDotsHover"
                  style="border-radius: 21px; width: 40px; height: 40px"
                >
                  <div class="dineDotsDiv">
                    <img src="static/img/NineDots.svg" height="21" width="21" />
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
        <div class>
          <div
            style="padding-left: 1.25rem !important; visibility: hidden"
            class="pb-3"
          >
            <i class="fa-workspace-icon fa fa-bell"></i>
          </div>
          <div
            class="pb-3"
            style="padding-left: 1.1rem !important; visibility: hidden"
          >
            <i class="fa fa-question-circle fa-workspace-icon"></i>
          </div>
          <!-- <div
            class="p-2"
            style="background: rgba(120, 222, 135, 1) 0% 0% no-repeat padding-box;
                    opacity: 1;
                    width: 60px;
                    height: 60px;"
          >-->
          <div v-if="isOpen" class="row accountCls">
            <div class="accountChildCls w-100">
              <div class="d-flex p-3 pt-4 singleAccount">
                <!-- <div class="col-6"> -->
                <div>
                  <img
                    v-bind:src="`${
                      user.image && user.image.length > 0
                        ? user.image
                        : 'static/img/faces/face-0.jpg'
                    }`"
                    width="40"
                    height="40"
                    class="rounded-circle"
                  />
                </div>
                <div class="pl-3">
                  <div
                    style="word-break: break-all; idth: 150px; max-width: 150px"
                  >
                    {{ user.firstName }} {{ user.lastName }}
                  </div>
                  <div
                    style="word-break: break-all; idth: 150px; max-width: 150px"
                  >
                    {{ user.email }}
                  </div>
                  <div class="pt-2">
                    <a
                      :href="`#/${$route.params.account_id}/${$route.params.workspace_id}/profile`"
                      >Profile Settings</a
                    >
                  </div>
                </div>
              </div>
              <div v-if="fiifiUsers.length > 0">
                <div
                  class="d-flex pt-2 pb-2 singleAccount"
                  v-for="item in fiifiUsers"
                  v-bind:key="item._id"
                  @click="switchAccount(item)"
                  style="cursor: pointer"
                >
                  <!-- <div class="col-6"> -->
                  <div class="pl-3">
                    <img
                      v-bind:src="`${
                        item.image && item.image.length > 0
                          ? item.image
                          : 'static/img/faces/face-0.jpg'
                      }`"
                      width="40"
                      height="40"
                      class="rounded-circle"
                    />
                  </div>
                  <div class="pl-3 pt-1">
                    <div
                      style="
                        word-break: break-all;
                        idth: 150px;
                        max-width: 150px;
                      "
                    >
                      {{ item.firstName }} {{ item.lastName }}
                    </div>
                    <div
                      style="
                        word-break: break-all;
                        idth: 150px;
                        max-width: 150px;
                      "
                    >
                      {{ item.email }}
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="d-flex p-2"
                style="cursor: pointer"
                @click="addAccount"
              >
                <div class="pl-4" style="font-size: 14px">
                  <i class="fa fa-user-plus"></i>
                </div>
                <div class style="padding-left: 1.4rem">Add Account</div>
              </div>
              <div class="d-flex p-2" style="cursor: pointer" @click="Logout">
                <div class="pl-4" style="font-size: 16px">
                  <i class="fa fa-sign-out-alt"></i>
                </div>
                <div class style="padding-left: 1.4rem">Log out</div>
              </div>
            </div>
          </div>

          <div class="p-2 workspace-account" @click="isOpen = !isOpen">
            <img
              style="cursor: pointer"
              v-bind:src="`${
                user.image && user.image.length > 0
                  ? user.image
                  : 'static/img/faces/face-0.jpg'
              }`"
              class="w-100 rounded-circle"
            />
          </div>
        </div>
      </div>

      <!-- <div
        class="sidebar-wrapper"
        ref="sidebarScrollArea"
        :style="sidebarStyle"
        :data-color="backgroundColor"
        :data-image="backgroundImage"
        :data-active-color="activeColor"
      >-->
      <div
        class="sidebar-wrapper"
        :style="sidebarStyle"
        :data-color="backgroundColor"
        :data-image="backgroundImage"
        :data-active-color="activeColor"
      >
        <div
          class="d-flex dropdown-switch-div"
          style="display: none !important"
        >
          <b-dropdown
            id="dropdown-grouped"
            variant="link"
            toggle-class="text-decoration-none switch-workspace"
          >
            <template v-slot:button-content>
              <div class="d-flex">
                <div style="margin-right: 17px; padding-top: 4px">
                  <b-avatar
                    variant="warning"
                    :size="30"
                    style="color: white"
                    square
                    :text="avatarText"
                  ></b-avatar>
                </div>
                <div style="width: 145px">
                  <div
                    style="color: #000000b3; text-align: left"
                    class="infoTitle"
                    v-if="currentWorkspace && currentWorkspace.workspace_title"
                    :title="currentWorkspace.workspace_title"
                  >
                    {{ currentWorkspace.workspace_title }}
                  </div>
                  <div style="color: #000000b3; text-align: left" v-else>
                    Untitled
                  </div>
                  <div
                    style="font-size: 11px; color: #000000b3; text-align: left"
                    class="infoType"
                    v-if="currentWorkspace && currentWorkspace.workspace_type"
                  >
                    {{ currentWorkspace.workspace_type }}
                  </div>
                </div>
              </div>
            </template>
            <b-dropdown-group id="dropdown-group-1" header="PERSONAL">
              <b-dropdown-item-button
                v-for="item in myWorkspaces"
                :key="item.workspace_id"
              >
                <div
                  class="d-flex"
                  style="padding-top: 8px; padding-bottom: 8px"
                  @click="switchWorkspaces(item)"
                >
                  <div style="margin-right: 8px">
                    <b-avatar
                      rounded="lg"
                      variant="success"
                      :size="30"
                      style="color: white"
                      square
                      :text="workspaceTitleText(item.workspace_title)"
                    ></b-avatar>
                  </div>
                  <div class="workspaceItemCls">
                    <div
                      style="color: #000000b3; text-align: left"
                      class="infoTitle"
                      :title="item.workspace_title"
                    >
                      {{ item.workspace_title }}
                    </div>
                    <div
                      style="
                        font-size: 11px;
                        color: #000000b3;
                        text-align: left;
                      "
                      class="infoType"
                    >
                      {{ item.workspace_type }}
                    </div>
                  </div>
                </div>
              </b-dropdown-item-button>
            </b-dropdown-group>
            <b-dropdown-group
              id="dropdown-group-2"
              class="sharedWorkspaceItem"
              header="SHARED"
            >
              <b-dropdown-item-button
                v-for="item in sharedWorkspace"
                :key="item.workspace_id"
              >
                <div
                  class="d-flex"
                  style="padding-top: 8px; padding-bottom: 8px"
                  @click="switchWorkspaces(item)"
                >
                  <div style="margin-right: 8px">
                    <b-avatar
                      rounded="lg"
                      variant="success"
                      :size="30"
                      style="color: white"
                      square
                      :text="workspaceTitleText(item.workspace_title)"
                    ></b-avatar>
                  </div>
                  <div class="workspaceItemCls">
                    <div
                      style="color: #000000b3; text-align: left"
                      class="infoTitle"
                      :title="item.workspace_title"
                    >
                      {{ item.workspace_title }}
                    </div>
                    <div
                      style="
                        font-size: 11px;
                        color: #000000b3;
                        text-align: left;
                      "
                      class="infoType"
                    >
                      {{ item.workspace_type }}
                    </div>
                  </div>
                </div>
              </b-dropdown-item-button>
              <!-- <b-dropdown-item-button>Second Grouped Item</b-dropdown-item-button> -->
            </b-dropdown-group>
          </b-dropdown>
        </div>
        <slot></slot>
        <ul class="nav" style>
          <slot name="links">
            <sidebar-item
              v-for="(link, index) in sidebarLinks"
              :key="link.name + index"
              :link="link"
            >
              <sidebar-item
                v-for="(subLink, index) in link.children"
                :key="subLink.name + index"
                :link="subLink"
              ></sidebar-item>
            </sidebar-item>
          </slot>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import api from "../../axios_api";
import SwitchNotification from "../../pages/Dashboard/Components/SwitchNotification";
export default {
  name: "sidebar",
  props: {
    title: {
      type: String,
      default: "fiifi",
    },
    backgroundColor: {
      type: String,
      default: "black",
      validator: (value) => {
        let acceptedValues = [
          "",
          "blue",
          "azure",
          "green",
          "orange",
          "red",
          "purple",
          "black",
        ];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    backgroundImage: {
      type: String,
      default: "static/img/stripe-pattern.png",
    },
    activeColor: {
      type: String,
      default: "success",
      validator: (value) => {
        let acceptedValues = [
          "primary",
          "info",
          "success",
          "warning",
          "danger",
        ];
        return acceptedValues.indexOf(value) !== -1;
      },
    },
    logo: {
      type: String,
      default: "static/img/vue-logo.png",
    },
    sidebarLinks: {
      type: Array,
      default: () => [],
    },
    autoClose: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isOpen: false,
      email: "",
      fiifiUsers: [],
    };
  },
  provide() {
    return {
      autoClose: this.autoClose,
    };
  },
  computed: {
    ...mapGetters("user", ["user"]),
    ...mapGetters("workspace", ["currentWorkspace"]),
    ...mapGetters("workspace", ["workspaces"]),
    workspacesData() {
      let data = JSON.parse(JSON.stringify(this.workspaces));
      data = data.filter((item) => {
        if (item.clientName && item.clientName._id) return item;
      });
      let result = _.chain(data)
        .groupBy("clientName._id")
        .map(function (v, i) {
          return {
            clientId: i,
            client_name:
              v[0].clientName.firstName != v[0].clientName.lastName
                ? `${v[0].clientName.firstName} ${v[0].clientName.lastName}`
                : v[0].clientName.firstName,
            account_workspace: _.map(v),
          };
        })
        .value();
      result.map((item) => {
        if (item.account_workspace) {
          item.account_workspace.map((workspaceItem) => {
            workspaceItem.workspace_id = workspaceItem.workspace._id;
            workspaceItem.workspace_title = workspaceItem.workspace.title
              ? workspaceItem.workspace.title
              : "Untitled";
            workspaceItem.workspace_type = workspaceItem.workspace
              .workspace_type
              ? workspaceItem.workspace.workspace_type
              : "";
          });
        }
      });
      return result;
    },
    myWorkspaces() {
      let data = this.workspacesData.find(
        (item) => item.clientId == this.$route.params.account_id
      );
      if (data) return data.account_workspace;
      else return [];
    },
    sharedWorkspace() {
      let data = [];
      let workspaces = this.workspacesData.filter(
        (item) => item.clientId != this.$route.params.account_id
      );
      workspaces.map((item) => {
        if (item.account_workspace) {
          item.account_workspace.map((item) => data.push(item));
        }
      });
      return data;
    },
    avatarText() {
      if (this.currentWorkspace.workspace_title) {
        let text = this.currentWorkspace.workspace_title.split(" ");
        text =
          text.length > 1
            ? `${text[0].charAt(0)} ${text[1].charAt(0)}`
            : text[0].charAt(0);
        return text;
      } else return "WS";
    },
    sidebarStyle() {
      return {
        //backgroundImage: `url(${this.backgroundImage})`
        //background: "#f5f5f5 0% 0% no-repeat padding-box",
        "background-color": "rgb(241, 241, 242)",
        opacity: "1",
        "border-right": "1px solid #eaeaea",
      };
    },
  },
  methods: {
    workspaceTitleText(title) {
      let text = title.split(" ");
      text =
        text.length > 1
          ? `${text[0].charAt(0)} ${text[1].charAt(0)}`
          : text[0].charAt(0);

      return text;
    },
    // makeDefault(item) {
    //   const self = this;
    //   if (item.is_default) return;
    //   else {
    //     let payload = {
    //       account_id: this.$route.params.account_id,
    //       workspace_id: item.workspace_id
    //     };
    //     this.$store
    //       .dispatch("workspace/apiDefaultWorkspace", payload)
    //       .then(res => {
    //         this.$store.commit("workspace/setDefaultPipeline", {
    //           payload: item
    //         });
    //         self.switchWorkspaces(item);
    //         // this.$toaster.success("Dafault workspace has been changed.");
    //       })
    //       .catch(err => {
    //         this.$toaster.error("Fail to update workspace information.", {
    //           err
    //         });
    //       });
    //   }
    // },
    switchWorkspaces(item) {
      this.$notifyClear();
      this.$notify({ component: SwitchNotification, timeout: 8000 });
      let userProfile = this.$store.getters["user/user"];
      let payload = {
        id: item.account,
        _id: item.account,
        workspace_id: item.workspace_id,
        image: userProfile.image ? userProfile.image : "",
        firstName: userProfile.firstName ? userProfile.firstName : "",
        lastName: userProfile.lastName ? userProfile.lastName : "",
        email: userProfile.email ? userProfile.email : "",
      };
      let fiifi = JSON.parse(localStorage.fiifi).user;
      if (fiifi && fiifi.workspace_id && fiifi.workspace_id.length > 0) {
        if (item.workspace_id == fiifi.workspace_id) {
          let data = this.$store.getters["portfolio/portfolioData"];
          this.$notifyClear();
          if (data && data.length > 0) {
            this.$router.push(
              `/${payload._id}/${payload.workspace_id}/dashboard/overview`
            );
            return;
          } else {
            this.$router.push(
              `/${payload._id}/${payload.workspace_id}/portfolio`
            );
            return;
          }
        }
      }
      var defaultPayload = {
        workspace_title: item.workspace_title,
        workspace_type: item.workspace_type,
        workspace_id: item.workspace_id,
        targetCapitalToDeployPercent: item.targetCapitalToDeployPercent,
        feeAndExpenseLoadAssumptionPercent:
          item.feeAndExpenseLoadAssumptionPercent,
      };
      this.$store.commit("workspace/setDefaultPipeline", {
        payload: defaultPayload,
      });
      this.$store.commit("user/workspace_id", {
        workspace_id: item.workspace_id,
      });
      this.$store
        .dispatch("workspacePlans/getWorkspacePlanFeatures", {
          workspace_id: item.workspace_id,
        })
        .then((plans) => {
          this.$store.dispatch("arbiter/start");
          this.$store.dispatch("portfolio/apiFetchPortfolio").then((data) => {
            if (data && data.length > 0) {
              this.$router.push(
                `/${payload._id}/${payload.workspace_id}/dashboard/overview`
              );
            } else {
              this.$notifyClear();
              this.$router.push(
                `/${payload._id}/${payload.workspace_id}/dashboard/overview`
              );
            }
          });
        });

      // let userProfile = this.$store.getters["user/user"];
      // let payload = {
      //   id: item.account,
      //   _id: item.account,
      //   workspace_id: item.workspace_id,
      //   image: userProfile.image ? userProfile.image : "",
      //   firstName: userProfile.firstName ? userProfile.firstName : "",
      //   lastName: userProfile.lastName ? userProfile.lastName : "",
      //   email: userProfile.email ? userProfile.email : ""
      // };
      // api
      //   .post("/switch/user", { encrypt: { data: payload } })
      //   .then(data => {
      //     this.$store.dispatch("arbiter/shutdown");
      //     let user = data.data.encrypt.success.user;
      //     user.token = data.data.encrypt.success.token;
      //     user.isNew = data.data.encrypt.success.isNew;
      //     this.$store.commit("user/token", {
      //       token: data.data.encrypt.success.token
      //     });
      //     this.$store.commit("portfolio/markData", {
      //       hasData: data.data.encrypt.success.hasData
      //     });
      //     let workspace = data.data.encrypt.success.workspaceDetails;
      //     var payload = {
      //       workspace_title: workspace.workspace.title,
      //       workspace_type: workspace.workspace.workspace_type,
      //       workspace_id: workspace.workspace._id
      //     };
      //     user.workspace_id = payload.workspace_id;
      //     this.$store.commit("workspace/setDefaultPipeline", {
      //       payload: payload
      //     });
      //     user.email = userProfile.email;
      //     if (userProfile.image) user.image = userProfile.image;
      //     this.$store.commit("user/user", {
      //       user
      //     });
      //     this.$store.dispatch("arbiter/start");
      //     this.$notify({ component: NotificationSample, timeout: 8000 });
      //     window.localStorage.setItem("email", userProfile.email);
      //     this.$router.push(`/${user._id}/${user.workspace_id}/`);
      //   })
      //   .catch(err => console.log(err));
    },
    async initScrollBarAsync() {
      await import("perfect-scrollbar/dist/css/perfect-scrollbar.css");
      const PerfectScroll = await import("perfect-scrollbar");
      PerfectScroll.initialize(this.$refs.sidebarScrollArea);
    },
    switchAccount(item) {
      item.id = item._id;
      api
        .post("/switch/user", { encrypt: { data: item } })
        .then((data) => {
          this.$store.dispatch("arbiter/shutdown");
          let user = data.data.encrypt.success.user;
          user.token = data.data.encrypt.success.token;
          user.isNew = data.data.encrypt.success.isNew;
          this.$store.commit("user/token", {
            token: data.data.encrypt.success.token,
          });
          this.$store.commit("portfolio/markData", {
            hasData: data.data.encrypt.success.hasData,
          });
          let workspace = data.data.encrypt.success.workspaceDetails;
          var payload = {
            workspace_title: workspace.workspace.title,
            workspace_type: workspace.workspace.workspace_type,
            workspace_id: workspace.workspace._id,
          };
          user.workspace_id = payload.workspace_id;
          this.$store.commit("workspace/setDefaultPipeline", {
            payload: payload,
          });
          user.email = item.email;
          if (item.image) user.image = item.image;
          this.$store.commit("user/user", {
            user,
          });
          this.$store.dispatch("arbiter/start");
          this.$notify({ component: SwitchNotification, timeout: 8000 });
          window.localStorage.setItem("email", item.email);
          this.displayUser(user._id);
          this.isOpen = false;
          this.$router.push(`/${user._id}/${user.workspace_id}/`);
        })
        .catch((err) => console.log(err));
    },
    addAccount() {
      let user = JSON.parse(window.localStorage.getItem("fiifi")).user;
      let userObj = {
        _id: user._id || user.id,
        workspace_id: user.workspace_id,
        image: user.image,
        firstName: user.first_name,
        lastName: user.last_name,
        email: user.email,
      };
      if (window.localStorage.getItem("fiifiUsers")) {
        let users = JSON.parse(window.localStorage.getItem("fiifiUsers"));
        if (users.findIndex((item) => item._id == userObj._id) == -1) {
          window.localStorage.removeItem("fiifiUsers");
          users.push(userObj);
          window.localStorage.setItem("fiifiUsers", JSON.stringify(users));
        }
      } else {
        let users = [];
        users.push(userObj);
        window.localStorage.setItem("fiifiUsers", JSON.stringify(users));
      }
      this.$router.push("/login?redirect=account");
    },
    Logout() {
      window.sessionStorage.clear();
      this.$toaster.success("You have been successfully logged out.");
      if (localStorage.getItem("fiifiUsers") && this.$route.params.account_id) {
        let fiifiUsers = JSON.parse(localStorage.getItem("fiifiUsers"));
        let index = fiifiUsers.findIndex(
          (item) => item._id == this.$route.params.account_id
        );
        fiifiUsers.splice(index, 1);
        window.localStorage.setItem("fiifiUsers", JSON.stringify(fiifiUsers));
      }
      this.$router.push("/login");
    },
    displayUser(account_id) {
      if (localStorage.getItem("fiifiUsers") && this.$route.params.account_id) {
        this.fiifiUsers = JSON.parse(localStorage.getItem("fiifiUsers"));
        let index = this.fiifiUsers.findIndex((item) => item._id == account_id);
        this.fiifiUsers.splice(index, 1);
      }
    },
  },
  mounted() {
    this.displayUser(this.$route.params.account_id);
    this.email = localStorage.getItem("email")
      ? localStorage.getItem("email")
      : "";
    this.$watch(
      () => {
        return this.$route.params.account_id;
      },
      (account_id) => {
        if (account_id) {
          this.displayUser(account_id);
        }
      }
    );
  },
  beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  },
};
</script>
<style>
.switch-workspace {
  padding: 0 !important;
  margin: 0 !important;
}
.accountCls {
  box-shadow: 0 0 black;
  width: 252px;
  /* height: 250px; */
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 0px 8px #00000007;
  border-radius: 3px;
  opacity: 1;
  z-index: 111;
  position: fixed;
  bottom: 0;
  margin-left: 65px !important;
}
@media (min-width: 992px) {
  .navbar-search-form-mobile,
  .nav-mobile-menu {
    display: none;
  }
}
.fa-workspace-icon {
  font-size: 20px !important;
  line-height: 29px;
}

.dineDotsDiv {
  float: right;
  padding-top: 6px;
  padding-right: 10px;
}

.nineDotsHover:hover {
  cursor: pointer;
  background: #3c31b1 0% 0% no-repeat padding-box;
}

.dropdown-toggle::after {
  padding-top: 20px !important;
  display: inline !important;
  /* margin-top: 96px !important;
  margin-left: 176px !important; */
  margin-top: -20px;
  float: right;
  vertical-align: 0em !important;
  content: "" !important;
  color: #fcfcfc !important;
  border-top: 0.3em solid;
  border-right: 0.3em solid transparent;
  border-bottom: 0;
  border-left: 0.3em solid transparent;
}

.dropdown-switch-div {
  /* border-bottom: 1px solid #ffffff; */
  /* border-top: 1px solid transparent; */
  margin-left: 7px;
  padding-left: 10px;
  padding-right: 10px;
  border-right: 1px solid #00000033;
  border-left: 1px solid #00000033;
}

.dropdown-switch-div .b-dropdown {
  /* padding-left: 5px; */
  /* padding-top: 15px; */
  /* padding-bottom: 10px; */
  /* padding-right: 5px; */
}

.dropdown-switch-div .show {
  /* background: #ffffff 0% 0% no-repeat padding-box; */
  /* box-shadow: 0px 3px 6px #00000029; */
  /* border: 1px solid #d5d5d5; */
  /* border-radius: 4px; */
}

.dropdown-switch-div .dropdown-menu {
  left: -6px !important;
  width: 204px;
  border-radius: 0px 0px 4px 4px;
  margin-top: 10px;
  box-shadow: 0px 3px 6px #00000029;
}
.dropdown-switch-div .dropdown-header {
  font-size: 10px !important;
  padding-left: 8px;
  padding-bottom: 2px;
}

.sharedWorkspaceItem .b-avatar {
  background-color: #837136;
}

.workspaceItemCls {
  margin-top: -6px;
  width: 145px;
}

.dropdown-switch-div .dropdown {
  /* position: absolute !important; */
}

.dropdown-switch-div .btn {
  border: 0 !important;
}

.dropdown-switch-div .b-avatar {
  border-radius: 5px !important;
}
</style>
